import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PodriaInteresarte from "./PodriaInteresarte";
import { CartContext } from "@context/CardContext";
import axios from "@fetch/axios";
import { TokenContext } from "@context/TokenContext";
import { LanguageCurrencyContext } from "@context/LanguageCurrencyContext";
import { useTranslation } from "@hooks/useTranslation";
import Spinner from "@components/Spinner";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";


const Carrito = () => {
  const navigate = useNavigate();
  const {  subtotalPay, totalQuantity,setTotalQuantity, setSubtotalPay, setDescuento, descuento,saveCartToLocalStorage } = useContext(CartContext);
  const { getToken,getVerified } = useContext(TokenContext);
  const [shipping, setShipping] = useState(null);
  const [totalPay, setTotalPay] = useState(null);
  const { currency, lang } = useContext(LanguageCurrencyContext);
  const [productos, setProductos] = useState([]);
  const { translate } = useTranslation();
  const { removeToCart } = useContext(CartContext);
  const [loading, setLoading] = useState(true)
  const MySwal = withReactContent(Swal)

  const realizarCompra = () => {
    const totalItems= JSON.parse(localStorage.getItem('cart'))?.length || 0;
    if (totalItems > 0) {
      if(!getToken() || !getVerified()){
        navigate("/checkout-guest")
      }else{
        navigate("/checkout-envio")
      }
    } else {
      navigate("/home")
    }
  }

  const remove = async (producto) => {
    setLoading(false)
    removeToCart(producto)
    await fetchCarrito();
    setLoading(true)
  }

  const fetchCarrito = async () => {

    setLoading(false)
    if (getToken() && localStorage.getItem('cartId',null) !== null) {

      try {

        const res = await axios.get('/cart/my/order?currency=' + currency + '&lang=' + lang + '&id=' + localStorage.getItem('cartId'),
          {
            headers: { 'Authorization': 'Bearer ' + getToken() }
          }
        );
        if (res.data) {
          setProductos(res.data.cart_products)
          setSubtotalPay(res.data.subtotal)
          setDescuento(res.data.discount)
          setShipping(res.data.shipping)
          setTotalPay(res.data.total)
        }


      } catch (error) {
      }

    }else{

        let cart = JSON.parse(localStorage.getItem('cart')) ?? [];
        const moneda = currency == 'mxn' ? 'MXN' : 'USD';

        const res = await axios.post('/cart-guest/change',
           {
            "products": cart,
            "currency": currency,
            "lang": lang
          }
        )

        if (res.data.errors) {

          MySwal.fire({
            text: res.data.message,
            icon: 'error',
            title: 'Oops...'
          })

        } else {

          cart = res.data;

          let total = 0;
          cart.forEach(element => {
            total += ((element.price_offer ? getValue(element.price_offer) : getValue(element.price)) * element.quantity);
          })
          total = valueFormat(total);
  
          saveCartToLocalStorage(cart);
          setProductos(cart)
          setTotalQuantity(cart.length)
          setSubtotalPay(total + ' ' + moneda)
          setDescuento(0)
          setShipping(0)
          setTotalPay(total + ' ' + moneda)
        }

    }
    setLoading(true)

  };

  function getValue(valor) {
    if (valor == null) return NaN;
    if (typeof valor === 'number' && !isNaN(valor)) return valor;

    const str = String(valor).trim();

    // Buscar el primer token numérico (soporta formatos como 1.234,56 ó 1,234.56)
    const matches = str.match(/-?\d{1,3}(?:[.,]\d{3})*(?:[.,]\d+)?/g);
    if (!matches) return NaN;

    let token = matches[0];

    const hasDot = token.indexOf('.') !== -1;
    const hasComma = token.indexOf(',') !== -1;

    let normalized = token;

    if (hasDot && hasComma) {
      // Ambos presentes: decidir cuál es decimal según el último separador
      const lastDot = token.lastIndexOf('.');
      const lastComma = token.lastIndexOf(',');
      if (lastDot > lastComma) {
        // '.' es decimal, quitar comas (miles)
        normalized = token.replace(/,/g, '');
      } else {
        // ',' es decimal, quitar puntos (miles) y convertir ',' -> '.'
        normalized = token.replace(/\./g, '').replace(/,/g, '.');
      }
    } else if (hasComma && !hasDot) {
      // Solo coma -> asumir coma decimal
      normalized = token.replace(/,/g, '.');
    } else if (hasDot && !hasComma) {
      // Solo punto -> si hay varios puntos, tratar último como decimal y unir los demás
      const dotCount = (token.match(/\./g) || []).length;
      if (dotCount > 1) {
        const parts = token.split('.');
        const dec = parts.pop();
        normalized = parts.join('') + '.' + dec;
      }
    }

    // Quitar cualquier carácter extraño restante (dejamos dígitos, '-', y '.')
    normalized = normalized.replace(/[^\d.-]/g, '');

    const num = Number(normalized);
    return isNaN(num) ? NaN : num;
  }

  function valueFormat(valor){
    const n = Number(valor || 0);
    if (isNaN(n)) return '';
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
  }

  useEffect(() => {

    fetchCarrito()

  }, [currency, lang])

  return (
    <>
      {!loading && <Spinner />}

      <section className="Carrito">
        <div className="CarritoList">
          <h4>{translate('shopping.title')}</h4>

          {productos.length > 0 && productos.map((producto, index) => (
            <div className="AgregadoItem" key={index}>

              <div>
                <div onClick={()=>{navigate('/detalles-producto/'+producto.uri)}} className="AgregadoItemImg"  style={{ backgroundImage: `url(${producto.desktop_image})`,cursor: 'pointer' }}  ></div>
                <div>
                  {producto.price_offer && <div className="textpromo">{translate('product.discount')}</div>}
                  <p>{producto.name}</p>
                  <em>
                    <b>{translate('product.size')}: </b>{producto.size}
                  </em>
                  {/* Mostrar el color seleccionado */}
                  {producto.color_name && (
                    <em>
                      <b>Color: </b>{producto.color_name}
                    </em>
                  )}
                  <em>{producto.description}</em>
                </div>
              </div>
              <div>
                {!producto.price_offer && <h6>{producto.quantity} x ${producto.price} </h6>
                }
                {producto.price_offer && <div className="grid-price">
                  <span>{producto.quantity} x ${producto.price}</span>
                  <div className="promo">{producto.quantity} x {producto.price_offer} </div>
                </div>}

                <div className="ButtonDarkThiny icon-Trash" onClick={() => { remove(producto) }}>{translate('product.delete')}</div>

              </div>
            </div>
          ))}

        </div>
        <div className="CarritoResume">

          <div className="Row">
            <p>{translate('shopping.total_products')}</p>
            <h6>{totalQuantity} </h6>
          </div>

          <div className="Row">
            <p>{translate('shopping.subtotal')}</p>
            <h6>{subtotalPay ? subtotalPay : `0.00 ${currency == 'mxn' ? 'MXN' : 'USD'}`}</h6>
          </div>


          <div className="Row">
            <p>{translate('shopping.discount')}</p>
            <h6>{descuento ? descuento : `0.00 ${currency == 'mxn' ? 'MXN' : 'USD'}`}</h6>
          </div>


          <div className="Row">
            <p>{translate('shopping.shipping')}</p>
            <h6>{shipping ? shipping : `0.00 ${currency == 'mxn' ? 'MXN' : 'USD'}`}</h6>
          </div>

          <div className="Row">
            <h5>Total:</h5>
            <h5>{totalPay ? totalPay : `0.00 ${currency == 'mxn' ? 'MXN' : 'USD'}`}</h5>
          </div>
          <div
            className="ButtonDark"
            onClick={() => realizarCompra()}
          >
            {translate('shopping.purchased')}
            <i className="icon-Check"></i>
          </div>
        </div>
      </section>
      <PodriaInteresarte />
    </>
  );
};
export default Carrito;
